import { App } from './core/App.js';
import { htmlLang, ui } from './config/i18n.js';

/**
 * Isidora
 * Italo Calvino, Invisible Cities — "Cities & Memory · 2"
 *
 * The whole piece is one descent. Everything else is in src/core/App.js.
 */

const canvas = document.getElementById('stage');
const overlay = document.getElementById('overlay');

async function boot() {
  // Before anything else, so the one thing that might be shown instead of the
  // city — a browser without WebGL — is already in the right language.
  document.documentElement.lang = htmlLang();
  document.documentElement.dataset.lang = htmlLang().slice(0, 2);

  if (!canvas.getContext('webgl2') && !canvas.getContext('webgl')) {
    overlay.innerHTML =
      '<p style="color:#cdb79a;font-family:serif;padding:2rem;text-align:center">' +
      `${ui('noWebgl')}</p>`;
    return;
  }

  const app = new App(canvas, overlay);
  await app.build();
  app.start();

  // Exposed on purpose: the city should be pokeable from a console.
  globalThis.isidora = app;

  if (import.meta.hot) {
    import.meta.hot.dispose(() => app.dispose());
  }
}

boot().catch((err) => {
  console.error('[isidora] failed to open', err);
  overlay.innerHTML = `<pre style="color:#c98;font:12px/1.5 monospace;padding:2rem;white-space:pre-wrap">${String(
    err?.stack ?? err,
  )}</pre>`;
});
